import SubHeader from "@/components/SubHeader";
import { isFilled } from "@prismicio/client";
import { PrismicNextImage } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";
import { getHighlightClassName } from "@/helpers";

/**
 * @typedef {import("@prismicio/client").Content.ProjectReviewSlice} ProjectReviewSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ProjectReviewSlice>} ProjectReviewProps
 * @type {import("react").FC<ProjectReviewProps>}
 */
const ProjectReview = ({ slice }) => {
  const { sub_header, text, author, role, picture } = slice.primary;

  const hasQuoteCard =
    isFilled.richText(text) ||
    isFilled.keyText(author) ||
    isFilled.keyText(role);

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-beige-30`}>
      <div className="framing">
        <div className="flex w-full flex-col gap-3">
          {isFilled.keyText(sub_header) && <SubHeader text={sub_header} />}

          {(hasQuoteCard) && (
            <div className="flex flex-col gap-5 md:flex-row md:items-stretch md:gap-10">
              {hasQuoteCard && (
                <div className={`flex flex-col justify-center gap-5 md:gap-10 p-[30px] md:shrink-0  
                ${slice.variation === "default" ?
                    "rounded-[20px] md:rounded-[30px] bg-blanc w-full" :
                    "bg-transparent border-l-2 border-rouge md:w-[460px] lg:w-[661px]"}`}>
                  {
                    isFilled.richText(text) && (
                      <PrismicRichText field={text} components={{
                        paragraph: ({ children }) => (
                          <p className="p-lg text-bleu italic">
                            {children}
                          </p>
                        ),
                      }} />
                    )
                  }
                  {
                    (isFilled.keyText(author) || isFilled.keyText(role)) && (
                      <div className="flex flex-col gap-1">
                        {isFilled.keyText(author) && (
                          <p className="p-lg-n sbd text-bleu">
                            {author}
                          </p>
                        )}

                        {isFilled.keyText(role) && slice.variation === "default" && (
                          <div className={`p-sm w-fit text-bleu`}>
                            {role}
                          </div>
                        )}
                        {isFilled.keyText(role) && slice.variation !== "default" && (
                          <div className={`name-text w-fit text-bleu ${getHighlightClassName(slice.variation === "default" ? 'beige-30' : 'beige')}`}>
                            {role}
                          </div>
                        )}
                      </div>
                    )
                  }
                </div>
              )}

              {isFilled.image(picture) && (
                <div className="relative h-[350px] overflow-hidden rounded-[20px] md:rounded-[30px] md:h-auto md:min-h-[305px] md:flex-1 ">
                  <PrismicNextImage
                    field={picture}
                    fill
                    className="object-cover"
                    sizes="(max-width: 768px) 100vw, 40vw"
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ProjectReview;
